//import fetch from 'cross-fetch';
import 'whatwg-fetch'
import ContentApi from './../api/ContentApi'

// ORG PART
export const ADD_REGISTER_PENDING   = 'ADD_REGISTER_PENDING';
export const ADD_REGISTER_SUCCESS   = 'ADD_REGISTER_SUCCESS';
export const ADD_REGISTER_FAILURE   = 'ADD_REGISTER_FAILURE';

export const LOAD_REQUESTS_PENDING  = 'LOAD_REQUESTS_PENDING';
export const LOAD_REQUESTS_COMPLETE = 'LOAD_REQUESTS_COMPLETE';
export const LOAD_ORGS_PENDING      = 'LOAD_ORGS_PENDING';
export const PREVIEW_IS_LOADING     = 'PREVIEW_IS_LOADING';
export const LOAD_ORGS_COMPLETE     = 'LOAD_ORGS_COMPLETE';
export const ADD_ORG_USER_PENDING   = 'ADD_ORG_USER_PENDING';
export const ADD_ORG_USER_COMPLETE  = 'ADD_ORG_USER_COMPLETE';

export const LOAD_USERS_PENDING     = 'LOAD_USERS_PENDING';
export const LOAD_USERS_COMPLETE    = 'LOAD_USERS_COMPLETE';    
export const ACTIVATE_ORG_USER      = 'ACTIVATE_ORG_USER';
export const DELETE_ORG_USER        = 'DELETE_ORG_USER';
export const ACTIVATE_USER_FAILED   = 'ACTIVATE_USER_FAILED';
export const DELETE_USER_FAILED     = 'DELETE_USER_FAILED';
export const FILL_ORG_PENDING       = 'FILL_ORG_PENDING';
export const FETCH_FAILURE          = 'FETCH_FAILURE';
export const LOGIN_PENDING          = 'LOGIN_PENDING';
export const LOGIN_COMPLETE         = 'LOGIN_COMPLETE';
export const LOAD_INSPECTIONS_PENDING = 'LOAD_INSPECTIONS_PENDING';
export const LOAD_INSPECTIONS_LIST_SUCCESS = 'LOAD_INSPECTIONS_LIST_SUCCESS';
export const LOAD_INSPECTIONS_SUCCESS = 'LOAD_INSPECTIONS_SUCCESS';
export const ADD_ORG_PENDING          = 'ADD_ORG_PENDING';
export const ADD_ORG_COMPLETE         = 'ADD_ORG_COMPLETE';
export const ADD_ORG_AND_USER_PENDING = 'ADD_ORG_AND_USER_PENDING';
export const ADD_ORG_AND_USER_COMPLETE = 'ADD_ORG_AND_USER_COMPLETE';
export const ADD_BO_PENDING          = 'ADD_BO_PENDING';
export const ADD_BO_COMPLETE         = 'ADD_BO_COMPLETE'
export const GET_BOS_PENDING          = 'GET_BOS_PENDING';
export const GET_BOS_COMPLETE         = 'GET_BOS_COMPLETE';
export const GET_COS_PENDING          = 'GET_COS_PENDING';
export const GET_COS_COMPLETE         = 'GET_COS_COMPLETE';
export const LOGIN_WITH_EDS_PENDING = 'LOGIN_WITH_EDS_PENDING';
export const LOGIN_WITH_EDS_COMPLETE = 'LOGIN_WITH_EDS_COMPLETE';

export const GET_NOTIFICATION_PENDING = "GET_NOTIFICATION_PENDING";
export const GET_NOTIFICATION_COMPLETE = "GET_NOTIFICATION_COMPLETE";


export const NEW_NOTIFICATION_PENDING = 'NEW_NOTIFICATION_PENDING';
export const NEW_NOTIFICATION_COMPLETE = 'NEW_NOTIFICATION_COMPLETE';

export const SAVE_NOTIFICATION_PENDING = 'SAVE_NOTIFICATION_PENDING';
export const SAVE_NOTIFICATION_COMPLETE = 'SAVE_NOTIFICATION_COMPLETE';

export const SIGN_NOTIFICATION_PENDING = 'SIGN_NOTIFICATION_PENDING';
export const SIGN_NOTIFICATION_COMPLETE = 'SIGN_NOTIFICATION_COMPLETE';

export const DECLINE_NOTIFICATION_PENDING = 'DECLINE_NOTIFICATION_PENDING';
export const DECLINE_NOTIFICATION_COMPLETE = 'DECLINE_NOTIFICATION_COMPLETE';

export const APPROVE_NOTIFICATION_PENDING = 'APPROVE_NOTIFICATION_PENDING';
export const APPROVE_NOTIFICATION_COMPLETE = 'APPROVE_NOTIFICATION_COMPLETE';

export const LOAD_NOTIFICATIONS_COMPLETE = 'LOAD_NOTIFICATIONS_COMPLETE';
export const LOAD_NOTIFICATIONS_PENDING = 'LOAD_NOTIFICATIONS_PENDING';

export const FILE_UPLOAD_COMPLETE = 'FILE_UPLOAD_COMPLETE';

export const REMOVE_UNSET_FILE_COMPLETE = 'REMOVE_UNSET_FILE_COMPLETE';
export const REMOVE_UNSET_FILE_PENDING = 'REMOVE_UNSET_FILE_PENDING';

export const SET_NOTIFICATION_SIGNED_PENDING = 'SET_NOTIFICATION_SIGNED_PENDING';
export const SET_NOTIFICATION_SIGNED_COMPLETE = 'SET_NOTIFICATION_SIGNED_COMPLETE';

export const SET_NOTIFICATION_APPROVED_PENDING = 'SET_NOTIFICATION_APPROVED_PENDING';
export const SET_NOTIFICATION_APPROVED_COMPLETE = 'SET_NOTIFICATION_APPROVED_COMPLETE';

export const SET_NOTIFICATION_DECLINED_PENDING = 'SET_NOTIFICATION_DECLINED_PENDING';
export const SET_NOTIFICATION_DECLINED_COMPLETE = 'SET_NOTIFICATION_DECLINED_COMPLETE';

export const SEARCH_CONCLUSION_PENDING = 'SEARCH_CONCLUSION_PENDING';
export const SEARCH_CONCLUSION_COMPLETE = 'SEARCH_CONCLUSION_COMPLETE';

export const SEARCH_CONCLUSIONS_PENDING = 'SEARCH_CONCLUSIONS_PENDING';
export const SEARCH_CONCLUSIONS_COMPLETE = 'SEARCH_CONCLUSIONS_COMPLETE';

export const SUBMIT_APPEAL_PENDING = 'SUBMIT_APPEAL_PENDING';
export const SUBMIT_APPEAL_COMPLETE = 'SUBMIT_APPEAL_COMPLETE';
export const SUBMIT_APPEAL_FAILED ='SUBMIT_APPEAL_FAILED';

export const SUBMIT_REPLY_COMPLETE = 'SUBMIT_REPLY_COMPLETE';
export const SUBMIT_REPLY_FAILED ='SUBMIT_REPLY_FAILED';

export const GET_REPLY_COMPLETE = 'GET_REPLY_COMPLETE';

export const LOAD_APPEALS_COMPLETE = 'LOAD_APPEALS_COMPLETE';

export const SUBMIT_INGOING_NUMBER_COMPLETE = 'SUBMIT_INGOING_NUMBER_COMPLETE';
export const SUBMIT_INGOING_NUMBER_PENDING = 'SUBMIT_INGOING_NUMBER_PENDING';

export const ORG_ADD_USER_COMPLETE = 'ORG_ADD_USER_COMPLETE';
export const LOAD_ORG_USERS_COMPLETE = 'LOAD_ORG_USERS_COMPLETE';
export const UPDATE_ORG_COMPLETE = 'UPDATE_ORG_COMPLETE';
export const LOAD_ORG_COMPLETE = 'LOAD_ORG_COMPLETE';

export const UPDATE_SELF_COMPLETE = 'UPDATE_SELF_COMPLETE';
export const LOAD_SELF_COMPLETE = 'LOAD_SELF_COMPLETE';
export const UPDATE_SELF_FAILED = 'UPDATE_SELF_FAILED';

export const CLEAR_REDIRECT = 'CLEAR_REDIRECT';
export const LOAD_BO_COMPLETE = 'LOAD_BO_COMPLETE';
export const CREATE_USER_COMPLETE =  'CREATE_USER_COMPLETE';

export const LOAD_USER_COMPLETE = 'LOAD_USER_COMPLETE';
export const UPDATE_USER_COMPLETE = 'UPDATE_USER_COMPLETE';

export const DELETE_NOTIFICATION_SUCCESS = 'DELETE_NOTIFICATION_SUCCESS';
export const DELETE_NOTIFICATION_FAILED = 'DELETE_NOTIFICATION_FAILED';

export const DELETE_REGISTRATION_COMPLETE = 'DELETE_REGISTRATION_COMPLETE';
export const DELETE_REGISTRATION_FAILED = 'DELETE_REGISTRATION_FAILED';

export const DELETE_INSPECTION_COMPLETE = 'DELETE_INSPECTION_COMPLETE';
export const DELETE_INSPECTION_FAILED = 'DELETE_INSPECTION_FAILED';

export const ACTIVATE_ORG_COMPLETE = 'ACTIVATE_ORG_COMPLETE';
export const ACTIVATE_ORG_FAILED = 'ACTIVATE_ORG_FAILED';

export const DELETE_ORG_COMPLETE = 'DELETE_ORG_COMPLETE';
export const DELETE_ORG_FAILED = 'DELETE_ORG_FAILED';

export const ADD_INSPECTION_COMPLETE = 'ADD_INSPECTION_COMPLETE';
export const ADD_INSPECTION_FAILED = 'ADD_INSPECTION_FAILED';

export const EDIT_INSPECTION_COMPLETE = 'EDIT_INSPECTION_COMPLETE';
export const EDIT_INSPECTION_FAILED = 'EDIT_INSPECTION_FAILED';

export const GET_TOTAL_PREVIEW_PENDING = 'GET_TOTAL_PREVIEW_PENDING';
export const GET_TOTAL_PREVIEW_COMPLETE = 'GET_TOTAL_PREVIEW_COMPLETE';
export const GET_PREVIEW_PENDING = 'GET_PREVIEW_PENDING';
export const GET_PREVIEW_COMPLETE = 'GET_PREVIEW_COMPLETE';

export const GET_ATTACHMENTS_PENDING = 'GET_ATTACHMENTS_PENDING';
export const GET_ATTACHMENTS_COMPLETE = 'GET_ATTACHMENTS_COMPLETE';

export const ADD_ATTACHMENT_PENDING = 'ADD_ATTACHMENT_PENDING';
export const ADD_ATTACHMENT_COMPLETE = 'ADD_ATTACHMENT_COMPLETE';

export const REMOVE_ATTACHMENT_PENDING = 'REMOVE_ATTACHMENT_PENDING';
export const REMOVE_ATTACHMENT_COMPLETE = 'REMOVE_ATTACHMENT_COMPLETE';


export const clearRedirectComplete = () => { return {type:CLEAR_REDIRECT}}
export const clearRedirect = () => (dispatch => { dispatch(clearRedirectComplete())})

    export const login = content => (
    dispatch => {
        dispatch(loginPending());
        fetch(
            `/login`,
            {
                method: 'POST',
                headers:
                {
                    "Content-Type": "application/json; charset=utf-8"
                },
                body: JSON.stringify(content)
            }
        ).then(response => response.json())
            .then(json => {
            dispatch(loginComplete(json));
            return json;
        }).catch(error => dispatch(fetchFailure(error)));
    ;
})

export const loginPending = () => ({ type: LOGIN_PENDING});
export const loginComplete = (json) => ({ type: LOGIN_COMPLETE, data: json, status:json.status});

export const fetchFailure = (error) =>
    ({
        type: FETCH_FAILURE,
        message: error.message
    })

// user wants register his company
export const addRegistration = content => (
    dispatch => {
    dispatch(addRegisterPending());
    fetch(
        `/register`,
        { method: 'PUT', headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
            body: JSON.stringify(content)})
        .then(response => response.json())
        .then(json => {
            if (json.status == 'success') {
                dispatch(addRegisterSuccess(json.message));
            } else  {
                dispatch(addRegisterFailure(json.message))    
            }
            return json.message;
        })
        .catch(error => dispatch(addRegisterFailure(error.message)));
        }
     );
// admin loads request
export const loadRegistrations = token => (
    dispatch =>
{
    dispatch(loadRequestsPending());
        fetch(`/api/admin/registrations`,
            {
                method: 'GET',
                headers: {"Content-Type": "application/json; charset=utf-8",
                          "Authorization": `Bearer ${token}`}
            }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (loadRequestsComplete(json))
            return json;
        })
});

export const loadRequestsPending = () => ({type: LOAD_REQUESTS_PENDING});

export const loadRequestsComplete = (data) => ({
    type: LOAD_REQUESTS_COMPLETE,
    data: data,
    requestsPending: false
})

export const addRegisterPending = () => ({
    type: ADD_REGISTER_PENDING,
    fetching: true
});
                        
export const addRegisterSuccess = (message) => ({
    type: ADD_REGISTER_SUCCESS,
    fetching: false,
    message: message,
    status:'completed'
});

export const addRegisterFailure = (message) => ({
    type: ADD_REGISTER_FAILURE,
    fetching: false,
    message: message,
    status:'failed'
});

export const loadOrgs = token => (
    dispatch => {
        dispatch(loadOrgsPending());
        fetch(`/api/admin/organizations`,{}).then(response => response.json())
            .then(json => (dispatch(loadOrgsComplete(json))))
            .catch(error => dispatch(fetchFailure(error)));
    }
)

export const addBoPending = () => ({
    type: ADD_BO_PENDING,
    fetching: true
});

export const addBoSuccess = (message) => ({
    type: ADD_BO_COMPLETE,
    fetching: false,
    message: message,
    status:'completed'
});

export const loadOrgsPending = () => ({type: LOAD_ORGS_PENDING, orgsFetching:true});
export const loadOrgsComplete = (json) => ({type: LOAD_ORGS_COMPLETE, data:json, orgsFetching:false });
export const addOrg = (token, data) => (
    dispatch => {
        dispatch(addOrgPending());
        fetch(`/admin/organization/`,{
            method: 'PUT',
            headers: {"Content-Type": "application/json; charset=utf-8", "Authoriation" : `Bearer ${token}` },
            body: ADD_REGISTER_PENDING
        }).then(response => response.json)
            .then(json => (dispatch(addOrgComplete(json))))
            .catch(error => dispatch(fetchFailure(error)));
    }
)
export const addOrgComplete = json => (
    {type: ADD_ORG_COMPLETE, orgAddFetching: false, data: json}
)

export const addOrgPending = () => (
    {type: ADD_ORG_PENDING, orgAddFetching: true}
)

export const addOrgUserPending = () => ({type: ADD_ORG_USER_PENDING, fetchAddOrgUser: true})
export const addOrgUserComplete = (response) => ({type: ADD_ORG_USER_COMPLETE, fetchOrgUser: false, response: response})
export const addOrgUser = (token, data) => (
    dispatch => {
        dispatch(addOrgUserPending());
        fetch('api/admin/user',
            {
                method: 'PUT',
                headers: {
                    "Content-type": "application/json; charset=utf-8", "Authorization" : `Bearer ${token}`
                },
                body: JSON.stringify(data)
            }).then(response => response.json)
            .then(json => (dispatch(addOrgUserComplete(json))))
            .catch(error => dispatch(fetchFailure(error)));

    }
)

export const addOrgAndUserByRequestPending = () => ({
   type: ADD_ORG_AND_USER_PENDING
})
export const addOrgAndUserByRequestComplete = (message) => ({
    type: ADD_ORG_AND_USER_COMPLETE,
    message:message
})
export const createOrgAndUserByRequest = (requestId, token) => ( dispatch => {
    console.log(requestId);
    console.log(token);
    dispatch(addOrgAndUserByRequestPending());
    fetch(`/api/admin/request/${requestId}/resolve`,{
         method: 'POST',
         headers: {
        "Content-type": "application/json; charset=utf-8", "Authorization" : `Bearer ${token}`
    } 
    }).then(response => response.json)
      .then(json => {dispatch(addOrgAndUserByRequestComplete(json));
            dispatch(loadRegistrations(token)); dispatch(loadOrgs(token)); dispatch(loadUsers(token))})
      .catch(error => {
            dispatch(fetchFailure(error));
        });
})


export const LOAD_CONTENT_SUCCESS = 'LOAD_CONTENT_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const RELOAD_LANGUAGE_DATA = 'RELOAD_LANGUAGE_DATA'


export function loadInitialData(action, json) {
    return {
        type: LOAD_INITIAL_DATA,
        action,
        content: json,
        receivedAt: Date.now()
    }
}

export const loadInspections = (token) => (
    dispatch => {
        dispatch(loadInspectionsPending());
        fetch(`/api/inspection/get/1`).then(response => response.json())
            .then(json => dispatch(loadInspectionsComplete(json)))
            .catch(error => {
                throw(error);
            });
})

export const loadInspectionsListComplete = (json) => {
    return {
        type: LOAD_INSPECTIONS_LIST_SUCCESS,
        data: json,
        inspectionsPending: false
    }
}

export const loadInspectionsList = (token) => (
    dispatch => {
        fetch(`/api/inspection/list`).then(response => response.json())
            .then(json => dispatch(loadInspectionsListComplete(json)))
            .catch(error => {
                throw(error);
            });
    })


export const newNotification = token => (
    dispatch =>
    {
        //dispatch(newNotificationPending());
        fetch(`/api/notification/create`,
            {
                method: 'POST',
                headers: {"Content-Type": "application/json; charset=utf-8",
                    "Authorization": `Bearer ${token}`}
            }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (newNotificationComplete(json, `notification/${json.id}`))
            return json;
        })
    });


export const loadInspectionsPending = () => ({
        type: LOAD_INSPECTIONS_PENDING,
        inspectionsPending: true
})

export const loadInspectionsComplete = (json) => ({
        type: LOAD_INSPECTIONS_SUCCESS,
        data: json,
        inspectionsPending: false
})


export const loadUsers = token => (
    dispatch =>   {
    dispatch(loadUsersPending());
    fetch(`/api/user/get/1`).then(response => response.json())
        .then(json => dispatch(loadUsersComplete(json)))
        .catch(error => dispatch(fetchFailure(error)));    
}

)
export const loadUsersPending = () => ({
    type: LOAD_USERS_PENDING,
    isUsersLoaded: false
})

export const loadUsersComplete = (json) => ({

    type: LOAD_USERS_COMPLETE,
    isUsersLoaded: true,
    data: json
})

export function logout() {
    localStorage.removeItem('user');
    return {
        type: LOGOUT
    }
}


export function changeLanguage(lang) {
    return {
        type: CHANGE_LANGUAGE,
        lang: lang,
        status: 'success'
    }
}

export function run(lang = 'ru') {
    return dispatch => {
        dispatch(loadInitialData(lang));
        return fetch(`/api/public/content/${lang}/home`)
            .then(response => response.json())
            .then(json => dispatch(loadInitialData(lang, json)))
    }
}

export function init(lang = 'ru') {
    return function(dispatch) {
        return ContentApi.init(lang).then(content => {
            dispatch(loadContentSuccess(content));
        }).catch(error => {
            throw(error);
        });
    };
}

export function loadContentSuccess(content) {
    return {type: 'LOAD_CONTENT_SUCCESS', content: content.data};
}

export const saveNotification = (id, notification, token) => ( dispatch => {
    dispatch(saveNotificationPending());
    console.log(notification);
    fetch(`/api/notification/${id}/save`,
        {
            method: 'POST',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`},
            body: JSON.stringify(notification)
        }
    ).then(response => response.json())
        .then(json => {
            if (json.status == 'success') {
                dispatch(saveNotificationComplete(json)); 
            } else 
                dispatch(fetchFailure(json));
            
        })
        .catch(error => dispatch(fetchFailure(error.message)));
    console.log(notification);
})

export const uploadFile = (document, item_id, notification, token) => (
    dispatch => {
        var data = new FormData() ;
        //data.append('doc', document.output('datauri'));
        data.append('id', item_id);
        data.append('file', document);
        fetch(`/api/notification/${item_id}/save`,
            {
                method: 'POST',
                headers: {"Content-Type": "application/json; charset=utf-8",
                    "Authorization": `Bearer ${token}`},
                body: JSON.stringify(notification)
            }
        ).then(response => response.json())
            .then(json => {
                if (json.status == 'success') {
                    fetch(`/api/save_notification_file`,{
                        method:'POST',
                        header: {"Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW"},
                        body: data}
                    ).then(response => response.json())
                        .then(json => {console.log('FILE'),console.log(json), dispatch(uploadFileComplete(json))})
                        .catch(error => {
                            dispatch(fetchFailure(error));
                        });
                } else
                    dispatch(fetchFailure(json));

            })
            .catch(error => dispatch(fetchFailure(error.message)));


    }
)

export const uploadFileComplete = (data) => {
    return {
        type: FILE_UPLOAD_COMPLETE,
        url: data.url,
        message: data.message,
    } 
}

export const addBo = (content, token) => (
    dispatch => {
        dispatch(addBoPending());
        content.token = token;
        fetch(
            `/api/admin/set-build-object`,
            { method: 'PUT', headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
                body: JSON.stringify(content)})
            .then(response => response.json())
            .then(json => {
                dispatch(addBoSuccess(json.message));
                return json.message;
            })
            .catch(error => dispatch(fetchFailure(error.message)));
    }
);

export const getBosPending = () => {
    return {
        type: GET_BOS_PENDING,
        objectsPending: true
    }
}

export const getBosComplete = (json) => {
    return {
        type: GET_BOS_COMPLETE,
        data: json.items,
        page: json.page,
        total: json.total,
        status: 'success'
    }
}

export const loadObjects = (token = '', page = 1, queryString = '', inspection_id = null) => (
  dispatch => {
    let data = new FormData();
    data.append('token', token);
    data.append('page', page);
    data.append('search', queryString);
    data.append('inspection_id', inspection_id);

    dispatch(getBosPending());
    fetch(`/api/objects/${page}/?_search=${queryString}`,
      {
        method: 'POST',
        body: data
      }).then(response => response.json()).then(json => {
      // console.log(json);
      dispatch(getBosComplete(json));
      return json;
    })
  });

export const getCosPending = () => {
    return {
        type: GET_COS_PENDING,
        objectsPending: true
    }
}

export const getCosComplete = (json) => {
    return {
        type: GET_COS_COMPLETE,
        data: json.items,
        page: json.page,
        total: json.total,
        status: 'success'
    }
}

export const loadConclusions = (token = '', page = 1, search = {} , inspection_id = null) => (
    dispatch =>
    {
        console.log(search);
        let data = (search instanceof FormData) ? search : new FormData();
        for ( var key in search) {
            console.log(search[key]);
            if (search[key] !== null && search[key] !== '')
            {data.append(key, search[key]);}
        }
        data.append('token', token);
        data.append('page', page);
        data.append('inspection_id', inspection_id);

        dispatch(getCosPending());
        fetch(`/conclusions/get/${page}`,
            {
                method: 'POST',
                body: data
            }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (getCosComplete(json))
            return json;
        })
    });


export const loadOrgObjects = (token = '', page = 1, queryString = '' ,inspection_id = null) => (
    dispatch =>
    {
        let data = new FormData();
        data.append('token', token);
        data.append('page', page);
        data.append('search', queryString);
        data.append('inspection_id', inspection_id)

        dispatch(getBosPending());
        fetch(`/org-objects`,
            {
                method: 'POST',
                body: data
            }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (getBosComplete(json))
            return json;
        })
    });

export const getPreviewPending = () => {
    return {
        type: GET_PREVIEW_PENDING
    }
}

export const previewIsLoading = (isLoading) => {
    return {
        type: PREVIEW_IS_LOADING,
        payload: isLoading
    }
}

export const getPreviewComplete = (json) => {
    return {
        type: GET_PREVIEW_COMPLETE,
        data: json
    }
};

export const getPreview = (items, query) => (
    dispatch => {
        dispatch(previewIsLoading(true));
        if (!query) {
            fetch(`/api/preview-objects/${0}`).then(response => response.json()).then(json => {
                dispatch(getPreviewComplete(json.items));
                dispatch(previewIsLoading(false));
            });
        } else {
            dispatch(getBosPending());
            let data = new FormData();
            data.append('search', query);
            data.append('inspection_id', null)
            fetch(`/api/objects-search/?_search=${query}`,
                {
                    method: 'POST',
                    body: data
                }).then(response => response.json()).then(json => {
                    dispatch(getPreviewComplete(json.items));
                    dispatch(getBosComplete(json));
                    dispatch(previewIsLoading(false));
                    return json;
                })
        }

    });

export const getTotalPreviewPending = () => {
    return {
        type: GET_TOTAL_PREVIEW_PENDING
    }
}

export const getTotalPreviewComplete = (json) => {
    console.log('complete preview');
    console.log(json);
    return {
        type: GET_TOTAL_PREVIEW_COMPLETE,
        total: json.total
    }

}

export const getTotalPreview = (search) => (

    dispatch => {
        dispatch(getTotalPreviewPending());
      if (search == '') {

        fetch(`/api/preview-total/objects`).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (getTotalPreviewComplete(json))
            return json;
        })
    }
    });

export const loginWithEdsPending = () => {
    return {
        type: LOGIN_WITH_EDS_PENDING
    }
}

export const loginWithEdsComplete = (json) => {
    return {
        type: LOGIN_WITH_EDS_COMPLETE,
        data: json,
        loginPending: false,
        message: json.message,
        status: 'success'
    }
}

export const loginWithEds = (code, unp, full_name, email) => (
    dispatch => {
        dispatch(loginWithEdsPending());
        fetch(
            `/eds_login?_eds=${code}`,
            {
                method: 'POST',
                headers: {"Content-Type": "application/json; charset=utf-8"},
                body: JSON.stringify({unp: unp, full_name: full_name, email: email})
            }
        ).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (loginWithEdsComplete(json))
            return json;
        }).catch(error => dispatch(fetchFailure(error.message)))
    }
)

export const newNotificationPending = () => {
    return {
        type: NEW_NOTIFICATION_PENDING,
    }
}

export const newNotificationComplete = (json, redirect) => {
    return {
        type: NEW_NOTIFICATION_COMPLETE,
        redirect: redirect,
        data: json

    }
}

export const saveNotificationPending = () => {
    return {
        type: SAVE_NOTIFICATION_PENDING,
    }
}

export const saveNotificationComplete = (json) => {
    return {
        type: SAVE_NOTIFICATION_COMPLETE,
        item: json.item,
        message: json.message
    }
}
export const signNotificationPending = () => {
    return {
        type: SIGN_NOTIFICATION_PENDING,
    }
}

export const signNotificationComplete = (json) => {
    return {
        type: SIGN_NOTIFICATION_COMPLETE,
        data: json
    }
}

export const loadNotificationPending = () => {
    return {
        type: LOAD_NOTIFICATIONS_PENDING,
    }
}

export const loadNotificationsComplete = (json) => {
    return {
        type: LOAD_NOTIFICATIONS_COMPLETE,
        data: json.items
    }
}

export const loadOrgNotifications = (token, id) => (
    dispatch =>
    {
        dispatch(loadNotificationPending());
        fetch(`/org-notifications`,
            {
                method: 'GET',
                headers: {"Content-Type": "application/json; charset=utf-8",
                    "Authorization": `Bearer ${token}`}
            }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (loadNotificationsComplete(json))
            return json;
        })
    });

export const loadNotifications = (token, page = 1) => (
    dispatch =>
    {
        dispatch(loadNotificationPending());
        fetch(`/api/notifications/${page}/`,
            {
                method: 'GET',
                headers: {"Content-Type": "application/json; charset=utf-8",
                    "Authorization": `Bearer ${token}`}
            }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (loadNotificationsComplete(json))
            return json;
        })
    });

export const loadInspectorNotifications = (token) => (
    dispatch =>
    {
        dispatch(loadNotificationPending());
        fetch(`/inspector-notifications`,
            {
                method: 'GET',
                headers: {"Content-Type": "application/json; charset=utf-8",
                    "Authorization": `Bearer ${token}`}
            }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (loadNotificationsComplete(json))
            return json;
        })
    });

export const removeUnsentFile = (id, token) => (
    dispatch =>
    {
       dispatch(removeUnsentFilePending());
       dispatch(removeUnsentFileComplete('smth'));
    }
)

export const removeUnsentFilePending  = () => {
    return {
        type: REMOVE_UNSET_FILE_PENDING,
    }
}

export const removeUnsentFileComplete  = (json) => {
    return {
        type: REMOVE_UNSET_FILE_COMPLETE,
        deleteResponse: json
    }
}
export const setNotificationSignedPending = () => {
    return {
        type: SET_NOTIFICATION_SIGNED_PENDING
    }
}

export const setNotificationSignedComplete = (json) => {
    return {
        type: SET_NOTIFICATION_SIGNED_COMPLETE,
        status: json.status,
        disabled: true,
        open: false
    }
}
export const setNotificationSigned = (id, token) => (
    dispatch => {
        dispatch(setNotificationSignedPending());
        fetch(`/api/notification/${id}/sign`,
            {
                method: 'POST',
                headers: {"Content-Type": "application/json; charset=utf-8", "Authorization": `Bearer ${token}`}
            }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (setNotificationSignedComplete(json))
            return json;
        })
    }
)

export const getNotificationPending = () => {
    return {
        type: GET_NOTIFICATION_PENDING
    }
}

export const getNotificationComplete = (json) => {
    return {
        type: GET_NOTIFICATION_COMPLETE,
        status: 'loaded',
        item: json
    }
}

export const getNotification = (id, token) => (
    dispatch => {
        getNotificationPending();
        fetch(
            `/api/notification/${id}/get`,
            {
                method: 'GET',
                headers: {"Content-Type": "application/json; charset=utf-8", "Authorization": `Bearer ${token}`}
            }
        ).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (getNotificationComplete(json))
            return json;
        })
    }
)

export const approveNotificationPending = () => {
    return {
        type: APPROVE_NOTIFICATION_PENDING
    }
}
export const declineNotificationPending = () =>  {
    return {
        type: DECLINE_NOTIFICATION_PENDING
    }
}
export const searchConclusionPending = () => {
    return {
        type: SEARCH_CONCLUSION_PENDING
    }
}
export const searchConclusionsPending = () => {
    return {
        type: SEARCH_CONCLUSIONS_PENDING
    }
}

export const approveNotificationComplete = (json) => {
    return {
        type: APPROVE_NOTIFICATION_COMPLETE,
        item: json.notification,
        reply: json.reply,
        bo: json.bo
    }
}
export const declineNotificationComplete = (json) => {
    return {
        type: DECLINE_NOTIFICATION_COMPLETE,
        item: json.notification,
        reply: json.reply
    }
}
export const searchConclusionComplete = (json) => {
     return {
         type: SEARCH_CONCLUSION_COMPLETE,
         conclusions:json
     }
}
export const searchConclusionsComplete = (json) => {
     return {
         type: SEARCH_CONCLUSIONS_COMPLETE,
         conclusions:json
     }
}

export const approveNotification = (id, data, token) => (dispatch => {
    dispatch(approveNotificationPending()),
     fetch(`/api/notification/${id}/approve`).then(response => response.json()).then(json => {
         console.log(json);
         dispatch (approveNotificationComplete(json))
         return json;
     })
})
export const declineNotification = (id, data, token) => (dispatch => {
    dispatch(declineNotificationPending());
    fetch(`/api/notification/${id}/decline`).then(response => response.json()).then(json => {
        console.log(json);
        dispatch (declineNotificationComplete(json))
        return json;
    })
})
export const searchConclusionByNotification = (notification_id, search, token) => (dispatch => {
    dispatch(searchConclusionPending());
    fetch(`/api/notification/${id}/conclusion`).then(response => response.json()).then(json => {
        console.log(json);
        dispatch (searchConclusionComplete(json))
        return json;
    })
})

export const searchConclusion = (search) => (dispatch => {
    dispatch(searchConclusionPending());
    var data = new FormData();
    data.append('search', search);
    fetch(`/conclusion`, {
        method: 'POST',
        header: {"Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW"},
        body: data
    }).then(response => response.json()).then(json => {
        console.log(json);
        dispatch (searchConclusionComplete(json))
        return json;
    })
})

export const searchConclusions = (no_id_array, token) => (dispatch => {
    dispatch(searchConclusionsPending());
    fetch(`/api/conclusions`).then(response => response.json()).then(json => {
        console.log(json);
        dispatch (searchConclusionsComplete(json))
        return json;
    })
})

export const submitAppealPending = () => {
    return {
        type: SUBMIT_APPEAL_PENDING
    }
}

export const submitAppealComplete = (json) => {
    return {
        type: SUBMIT_APPEAL_COMPLETE,
        status: json.status,
        message: json.message
    }
}

export const submitAppealFailed = (json) => {
    return {
        type: SUBMIT_APPEAL_FAILED,
        status: json.status,
        message: json.message,
        errors: json.errors
    }
}

export const submitAppeal = data => (dispatch => {
    dispatch(submitAppealPending());
    fetch(
        `/appeal`,
        { method: 'PUT', headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
            body: JSON.stringify(data)})
        .then(response => response.json())
        .then(json => {
            if (json.status == 'success') {
                dispatch(submitAppealComplete(json))
            } else {
                dispatch(submitAppealFailed(json))
            }
            return json;
        })
        .catch(error => dispatch(addRegisterFailure(error.message)));
})

export const submitReplyComplete = (json) => {
    return {
        type: SUBMIT_REPLY_COMPLETE,
        status: json.status,
        message: json.message,
        notification: json.notification,
        reply: json.reply
    }
}

export const submitReplyFailed = (json) => {
    return {
        type: SUBMIT_REPLY_FAILED,
        status: json.status,
        message: json.message,
        errors: json.errors
    }
}

export const submitIngoingNumberComplete = (json) => {
    return {
        type: SUBMIT_INGOING_NUMBER_COMPLETE,
        item: json.item
    }
}

export const submitIngoingNumber = (number, id, token) => (
    dispatch => {
        console.log(id);
        let $data = new FormData();
        $data.append('id', id);
        $data.append('ingoing_number', number);
        $data.append('token', token);
        fetch(`/submit-ingoing-number`,{
            method:'POST',
            header:{"Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW",
            "Authorization": `Bearer ${token}`},
            body: $data}).then(response => response.json())
            .then(json => {
                if (json.status == 'success') {
                    dispatch(submitIngoingNumberComplete(json))
                } else {
                    dispatch(fetchFailure(json))
                }
                return json;
            })
            .catch(error => dispatch(fetchFailure(error)));

    })

export const submitReply = (content,id,token) => (
    dispatch => {
    console.log(content);
    console.log(token);
        var data = new FormData() ;
        data.append('token', token);

        data.append('notification_id', id);
        data.append('status', content.status);
        data.append('comment_text', content.comment_text);
        data.append('notification_id', id);
        // // data.append('file', content.file);
        //
         if (content.status == 'APPROVED') {
             data.append('reply_type', content.reply_type);
             data.append('reply_number', content.reply_number);
             data.append('building_object_registration_number',  content.building_object_registration_number);
             data.append('building_object_registration_date',  content.building_object_registration_date);
         };
        //  console.log(formData);
        fetch(`/reply`,{
            method:'POST',
            header: {"Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW",
            "Authorization": `Bearer ${token}`
            },
            body: data})

        .then(response => response.json())
        .then(json => {
            if (json.status == 'success') {
                dispatch(submitReplyComplete(json))
            } else {
                dispatch(submitReplyFailed(json))
            }
            return json;
        })
        .catch(error => dispatch(addRegisterFailure(error.message)));
})

export const getReplyPending = () => {
    return {
        type: 'GET_REPLY_PENDING'
    }
}

export const getReplyComplete = (json) => {
    return {
        type: 'GET_REPLY_COMPLETE',
        item: json.item
    }
}

export const getReply = (id, token) => (
    dispatch => { dispatch(getReplyPending());
        fetch(`/reply/${id}/get`, {
            method: 'GET',
            header: {"Authorization": `Bearer ${token}`}
        }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch(getReplyComplete(json))
            return json;
        })
    }
)

export const loadAppealsComplete = (json) => {
    return {
        type: LOAD_APPEALS_COMPLETE,
        appeals: json.items
    }
}

export const loadAppeals = (token, page = 1) => (
    dispatch => { 
        fetch(`/appeals/${page}`, {
            method: 'GET',
            headers: {"Authorization": `Bearer ${token}`}
        }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch(loadAppealsComplete(json))
            return json;
        })
    }
)

export const loadOrgComplete = (json) => {
    return {
        type: LOAD_ORG_COMPLETE,
        org: json.org
    }
}
export const loadOrg = (token) => (
    dispatch => {
        let data = new FormData();
        data.append('token', token);
        fetch(`/org-profile/`, {
            method:'POST',
            headers: {"Authorization": `Bearer ${token}`},
            body: data
        }).then(response => response.json())
            .then(json => {
                if (json.status == 'success') {
                    dispatch(loadOrgComplete(json))
                } else {
                    dispatch(fetchFailure(json))
                }
                return json;
            })
            .catch(error => dispatch(fetchFailure(error)));
    }
)
export const updateOrgComplete = (json) => {
    return {
        type: UPDATE_ORG_COMPLETE,
        status: json.status,
        message: json.message,
        org: json.org
    }
}
export const updateOrg = (token, form) => (
    dispatch => {
        let $data = new FormData();
        $data.append('okpo', form.okpo);
        $data.append('region', form.region);
        $data.append('state', form.state);
        $data.append('website', form.website);
        $data.append('tax_company_name', form.tax_company_name);
        $data.append('certificate_number', form.certificate_number);
        $data.append('certificate_date', form.certificate_date);
        $data.append('phones', form.phones);
        $data.append('email', form.email);
        $data.append('street', form.street)
        $data.append('token', token);
        fetch(`/update-org`,{
            method:'POST',
            header:{"Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW",
                "Authorization": `Bearer ${token}`},
            body: $data}).then(response => response.json())
            .then(json => {
                if (json.status == 'success') {
                    dispatch(updateOrgComplete(json))
                } else {
                    dispatch(fetchFailure(json))
                }
                return json;
            })
            .catch(error => dispatch(fetchFailure(error)));
    }
)

export const loadOrgUsersComplete = (json) => {
    return {
        type: LOAD_ORG_USERS_COMPLETE,
        items: json.items
    }
}

export const loadOrgUsers = (token) => (
    dispatch => {
        fetch(`/org-users`,{
            method:'GET',
            headers:{"Content-Type": "application/json; charset=utf-8","Authorization": `Bearer ${token}`}}).then(response => response.json())
            .then(json => {
                if (json.status == 'success') {
                    dispatch(loadOrgUsersComplete(json))
                } else {
                    dispatch(fetchFailure(json))
                }
                return json;
            })
            .catch(error => dispatch(fetchFailure(error)));
    }
)

export const orgAddUserComplete = (json) => {
    return {
        type: ORG_ADD_USER_COMPLETE,
        items: json.items,
        message: json.message,
        status: json.status
    }
}

export const orgAddUser = (token, user_form) => (
    dispatch => {
        let $data = new FormData();
        $data.append('full_name', user_form.full_name);
        $data.append('email', user_form.email);
        $data.append('password', user_form.password);
        $data.append('token', token);
        fetch(`/add-org-user`,{
            method:'POST',
            header:{"Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW",
                "Authorization": `Bearer ${token}`},
            body: $data}).then(response => response.json())
            .then(json => {
                if (json.status == 'success') {
                    dispatch(orgAddUserComplete(json))
                } else {
                    dispatch(fetchFailure(json))
                }
                return json;
            })
            .catch(error => dispatch(fetchFailure(error)));

    }
)

export const updateSelfComplete = (json) => {
    return {
        type: UPDATE_SELF_COMPLETE,
        message: json.message,
        item: json.item
    }
}
export const updateSelf = (token, form_data) => ( dispatch => {
    let data = new FormData();
    data.append('full_name', form_data.full_name);
    data.append('email', form_data.email);
    if (typeof form_data.password !== 'undefined' && form_data.password !== 'undefined') {
        data.append('password', form_data.password);
    }
    data.append('token', token);
    fetch(`/update-self`,{
        method:'POST',
        header:{"Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW",
            "Authorization": `Bearer ${token}`},
        body: data}).then(response => response.json())
        .then(json => {
            if (json.status == 'success') {
                dispatch(updateSelfComplete(json));
            } else  {
                dispatch(updateSelfFailed(json));
            }

            return json;
        })
        .catch(error => dispatch(fetchFailure(error)));

})

export const updateSelfFailed = (json) => {
    return {
        type: UPDATE_SELF_FAILED,
        message: json.message
    }
}

export const loadSelfComplete = (json) => {
    return {
        type: LOAD_SELF_COMPLETE,
        item: json.item
    }
}

export const loadSelf = (token) => ( dispatch => {
    fetch(`/load-self`, {
        headers:{"Content-Type": "application/json; charset=utf-8","Authorization": `Bearer ${token}`}})
        .then(response => response.json())
        .then(json => {
            if (json.status == 'success') {
                dispatch(loadSelfComplete(json))
            } else {
                dispatch(fetchFailure(json))
            }
            return json;
        })
        .catch(error => dispatch(fetchFailure(error)));

})

export const loadAdminObjects = (token, page = 1, queryString = '') => (
    dispatch =>
    {
        let form = new FormData();
        form.append('token', token);
        form.append('page', page);
        form.append('_search', queryString);

        dispatch(getBosPending());
        fetch(`/admin/objects`,
            {
                method: 'POST',
                body: form,
                headers:  {'Authorization': `Bearer ${token}`}
            }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (getBosComplete(json))
            return json;
        })
    });


export const changePublishState = (id, token) => (
    dispatch => {
        fetch(`/admin/object/${id}/publish`,
            {
                method: 'POST',
            }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (loadBoComplete(json))
            return json;
        })
    }
)

export const loadBoComplete = (json) => {return {type:LOAD_BO_COMPLETE,  item: json.item, message: json.message}}
export const loadBo = (id, token) => (
    dispatch => {
        fetch(`/admin/object/${id}/load`,
            {
                method: 'GET',
            }).then(response => response.json()).then(json => {
            dispatch (loadBoComplete(json))
            return json;
        })
    }
)

export const saveBo = (id, token, form) => (
    dispatch => {
        form.token = token;
        fetch(`/admin/object/${id}/save`,
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(form)
            }).then(response => response.json()).then(json => {
            console.log(json);
            dispatch (loadBoComplete(json))
            return json;
        })
    }
)

export const createUserComplete = (json) => { return { type: CREATE_USER_COMPLETE, message:json.message, item:json.item}}
export const createUser = (token, user_form, type, id) => (
    dispatch => {
        let content = user_form;
        content.org_type = type;
        content.org_id = id;
        console.log(content);
        fetch(
            `/admin/add-user`,
            { method: 'PUT', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            },
                body: JSON.stringify(content)})
            .then(response => response.json())
            .then(json => {
                    console.log(json);
                    dispatch(createUserComplete(json));
                return json;
            })
            .catch(error => dispatch(fetchFailure(error)));
})

export const updateUserComplete = (json) => {
    return {
        type: UPDATE_USER_COMPLETE,
        message: json.message,
        item: json.item,
    }
}

export const updateUser = (token, user_form, id) => (
    dispatch => {
        fetch(
            `/admin/user/${id}/edit`,
            { method: 'POST', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            },
                body: JSON.stringify(user_form)})
            .then(response => response.json())
            .then(json =>  {dispatch(updateUserComplete(json));return json.message;
            })
            .catch(error => dispatch(fetchFailure(error)));
    })

export const loadUserComplete = (json) => {
     return {
         type: LOAD_USER_COMPLETE,
         item: json.item
     }
}

export const loadUser = (id,token) => (
    dispatch => {
        fetch(
            `/api/user/${id}/get`,
            { method: 'GET', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            }})
            .then(response => response.json())
            .then(json =>  {dispatch(loadUserComplete(json));return json.message;
            })
            .catch(error => dispatch(fetchFailure(error)));
    })

export const deleteNotificationComplete = (json) => {
     return {
         type: DELETE_NOTIFICATION_SUCCESS,
         status: json.status,
         message: json.message
     }
}

export const deleteNotificationFailed = (json) => {
    return {
        type: DELETE_NOTIFICATION_FAILED,
        status: json.status,
        message: json.message
    }
}

export const deleteNotification = (id, token) => (
    dispatch => {
        fetch(
            `/api/notification/${id}/delete`,
            { method: 'DELETE', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            }})
            .then(response => response.json())
            .then(json =>  {
                if (json.status == 'success') {  dispatch(deleteNotificationComplete(json));}
                else { dispatch(deleteNotificationFailed(json))}
                return json.message;
            })
            .catch(error => dispatch(fetchFailure(error)));
    })

export const deleteRegistrationFailed = (json) => {
    return {
        type: DELETE_REGISTRATION_FAILED,
        message: json.message,
        status: 'error',
    }
}

export const deleteRegistrationComplete = (json) => {
    return {
        type: DELETE_REGISTRATION_COMPLETE,
        message: json.message,
        items: json.items,
    }
}

export const deleteRegistration = (id, token) => (
    dispatch => {
        fetch(
            `/registration/${id}/delete`,
            { method: 'DELETE', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            }})
            .then(response => response.json())
            .then(json =>  {
                if (json.status == 'success') {  dispatch(deleteRegistrationComplete(json));}
                else { dispatch(deleteRegistrationFailed(json))}
                return json.message;
            })
            .catch(error => dispatch(fetchFailure(error)));
    })



export const deleteInspection = (id, token) => (
    dispatch => {
        fetch(
            `/inspection/${id}/delete`,
            { method: 'DELETE', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            }})
            .then(response => response.json())
            .then(json =>  {
                if (json.status == 'success') {  dispatch(deleteRegistrationComplete(json));}
                else { dispatch(deleteRegistrationFailed(json))}
                return json.message;
            })
            .catch(error => dispatch(fetchFailure(error)));
    })

export const deleteOrgComplete = (json) => {
    return {
        type: DELETE_ORG_COMPLETE,
        message: json.message,
        items: json.items
    }
}

export const deleteOrgFailed = (json) => {
    return {
        type: DELETE_ORG_FAILED,
        message: json.message
    }
}

export const activateOrgComplete = (json) => {
    return {
        type: ACTIVATE_ORG_COMPLETE,
        message: json.message,
        items: json.items
    }
}

export const activateOrgFailed = (json) => {
    return {
        type: ACTIVATE_ORG_FAILED,
        message: json.message
    }
}

export const deleteOrg = (id, token) => (
    dispatch => {
        fetch(
            `/org/${id}/delete`,
            { method: 'DELETE', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            }})
            .then(response => response.json())
            .then(json =>  {
                if (json.status == 'success') {  dispatch(deleteOrgComplete(json));}
                else { dispatch(deleteOrgFailed(json))}
                return json.message;
            })
            .catch(error => dispatch(fetchFailure(error)));
    })

export const activateOrg = (id, token) => (
    dispatch => {
        fetch(
            `/org/${id}/activate`,
            { method: 'GET', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            }})
            .then(response => response.json())
            .then(json =>  {
                if (json.status == 'success') {  dispatch(activateOrgComplete(json));}
                else { dispatch(activateOrgFailed(json))}
                return json.message;
            })
            .catch(error => dispatch(fetchFailure(error)));
    })

export const activateUserComplete = (json) => {
    return {
        type: ACTIVATE_ORG_USER,
        message: json.message,
        items: json.items
    }
}

export const deleteUserComplete = (json) => {
    return {
        type: DELETE_ORG_USER,
        message: json.message,
        items: json.items
    }
}

export const activateUserFailed = (json) => {
    return {
        type: ACTIVATE_USER_FAILED,
        message: json.message,
        items: json.items
    }
}

export const deleteUserFailed = (json) => {
    return {
        type: DELETE_USER_FAILED,
        message: json.message
    }
}

export const deleteUser = (id, token) => (
    dispatch => {
        fetch(
            `/user/${id}/delete`,
            { method: 'DELETE', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            }})
            .then(response => response.json())
            .then(json =>  {
                if (json.status == 'success') {  dispatch(deleteUserComplete(json));}
                else { dispatch(deleteUserFailed(json))}
                return json.message;
            })
            .catch(error => dispatch(fetchFailure(error)));
    })

export const activateUser = (id, token) => (
    dispatch => {
        fetch(
            `/user/${id}/activate`,
            { method: 'GET', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            }})
            .then(response => response.json())
            .then(json =>  {
                if (json.status == 'success') {  dispatch(activateUserComplete(json));}
                else { dispatch(activateUserFailed(json))}
                return json.message;
            })
            .catch(error => dispatch(fetchFailure(error)));
    })

export const editInspectionComplete = (json) => {
    return {
        type: EDIT_INSPECTION_COMPLETE,
        message: json.message,
        items: json.items
    }
}

export const editInspectionFailed = (json) => {
    return {
        type: EDIT_INSPECTION_FAILED,
        message: json.message
    }
}
 // body!

export const editInspection = (id, data ,token) => (
    dispatch => {
        fetch(
            `/inspection/${id}/delete`,
            { method: 'POST', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            }})
            .then(response => response.json())
            .then(json =>  {
                if (json.status == 'success') {  dispatch(editInspectionComplete(json));}
                else { dispatch(editInspectionFailed(json))}
                return json.message;
            })
            .catch(error => dispatch(fetchFailure(error)));
    })

export const addAttachmentPending = ( ) => {
    return {
        type: ADD_ATTACHMENT_PENDING
    }
}

export const addAttachmentComplete = (json) => {
    return {
        type: ADD_ATTACHMENT_COMPLETE,
        items: json.items,
        message: json.message,
        status: json.status
    }
}

export const addAttachment = (token, notification_id, data) => (
    dispatch => {
        dispatch(addAttachmentPending());
        if (data instanceof FormData)  {
            data.append('key', token);
            data.append('notification_id', notification_id);
            fetch(`/notification/${notification_id}/attachment/add`,{method: 'POST', body: data}).then(response => response.json())
                .then(json =>  {
                    if (json.status == 'success') {  dispatch(addAttachmentComplete(json));}
                    else { dispatch(fetchFailure(json))}
                    return json.message;
                })
                .catch(error => dispatch(fetchFailure(error)));

        }

    }
)

// get Attachments

export const getAttachmentsComplete = (json) => {
    return {
        type: GET_ATTACHMENTS_COMPLETE,
        items: json.items,
        message: json. message
    }
}

export const getAttachments = (token, notification_id) => (
    dispatch => {
    fetch(`/notification/${notification_id}/attachments/get`).then(response => response.json()).then(json =>  {
            if (json.status == 'success') {  dispatch(getAttachmentsComplete(json));}
            else { dispatch(fetchFailure(json))}
            return json.message;
        }).catch(error => dispatch(fetchFailure(error)))
    }
    )

// remove attachment

export const removeAttachmentPending = () => {
    return {
        type: REMOVE_ATTACHMENT_PENDING
    }
}

export const removeAttachment = (token, notification_id, id) => (
    dispatch => {
    dispatch(removeAttachmentPending());
    fetch(`/notification/${notification_id}/attachment/${id}/delete`,{method: 'DELETE'})
        .then(response => response.json()).then(json =>  {
        if (json.status == 'success') {  dispatch(getAttachmentsComplete(json));}
        else { dispatch(fetchFailure(json))}
        return json.message;
    }).catch(error => dispatch(fetchFailure(error)))
    }
)


// body!

export const addInspectionComplete = (json) => {
    return {
        type: ADD_INSPECTION_COMPLETE,
        message: json.message,
        items: json.items
    }
}

export const addInspectionFailed = (json) => {
    return {
        type: ADD_INSPECTION_FAILED,
        message: json.message
    }
}
export const addInspection = (data, token) => (
    dispatch => {
        fetch(
            `/inspection/${id}/delete`,
            { method: 'PUT', headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${token}`
            }})
            .then(response => response.json())
            .then(json =>  {
                if (json.status == 'success') {  dispatch(addInspectionComplete(json));}
                else { dispatch(addInspectionFailed(json))}
                return json.message;
            })
            .catch(error => dispatch(fetchFailure(error)));
    })


// WEBPACK FOOTER //
// ./assets/src/js/actions/actions.js